import { createContext } from 'react';
import type { BusinessProfile, BusinessTemplate, CreateInput, ID, UpdateInput } from '@/types';

export interface BusinessContextValue {
  businesses: BusinessProfile[];
  activeBusiness: BusinessProfile | null;
  template: BusinessTemplate | null;
  isReady: boolean;
  /** Creates the profile *and* seeds its catalog from configuration. */
  createBusiness: (input: CreateInput<BusinessProfile>) => Promise<BusinessProfile>;
  updateBusiness: (id: ID, patch: UpdateInput<BusinessProfile>) => Promise<BusinessProfile>;
  /** Makes another business on this device the active one. Unknown ids are ignored. */
  setActiveBusiness: (id: ID) => Promise<void>;
  /**
   * A screen holding unsaved edits to the active business says so here, by an
   * owner key, so switching business can ask before those edits are discarded.
   * It never saves them.
   */
  setUnsavedChanges: (owner: string, dirty: boolean) => void;
  hasUnsavedChanges: () => boolean;
}

export const BusinessContext = createContext<BusinessContextValue | null>(null);
